import React, { Component } from 'react';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';

import './CalendarDateRangePicker.css';

class CalendarDateRangePicker extends Component {

  handleOnChange = (date) => {
    this.props.onDateChange(date);
  }

  render() {
    const { format = 'dd/MM/yyyyy', value = [], maxDate = new Date(), ...rest } = this.props;

    return (
      <div>
        <DateRangePicker
          format={ format }
          rangeDivider="&#8594;"
          showLeadingZeros={ true }
          value={ value }
          clearIcon={ null }
          calendarIcon={ null }
          maxDate={ maxDate }
          { ...rest }
          onChange={ this.handleOnChange }
        />
      </div>
      );
    }
  }

export default CalendarDateRangePicker;